import { render, staticRenderFns } from "./PostsDisplay.vue?vue&type=template&id=091ae033&scoped=true"
import script from "./PostsDisplay.vue?vue&type=script&lang=js"
export * from "./PostsDisplay.vue?vue&type=script&lang=js"
import style0 from "./PostsDisplay.vue?vue&type=style&index=0&id=091ae033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091ae033",
  null
  
)

export default component.exports